export const config = {
  title: "Carlos Cabral EXP Realty | Real Estate Agent | Montclair, NJ",
  meta: {
    description:
      "Carlos Cabral, professional real estate agent with EXP Realty in Montclair, NJ. Expert guidance for buying, selling, and investing in New Jersey real estate with cutting-edge technology and personalized service.",
    keywords: [
      "Carlos Cabral",
      "EXP Realty",
      "Real Estate Agent Montclair",
      "Montclair NJ Homes",
      "New Jersey Real Estate",
      "Home Buying Montclair",
      "Home Selling NJ",
      "Real Estate Investment"
    ],
    author: "Carlos Cabral",
    canonicalUrl: "https://www.carloscsellshomes.com/",
    imageURL: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=2073&auto=format&fit=crop&ixlib=rb-4.0.3",
  },
  sections: {
    header: {
      businessName: "Carlos Cabral EXP Realty",
    },
    sectionB: {
      heroTitle: "Your Trusted Real Estate Partner in Montclair, NJ",
      heroSubtitle: "Expert Guidance with Cutting-Edge Technology & Personalized Service",
      learnAboutText: "Get Your Free Market Analysis",
      phoneNumber: "5515871638",
      phoneLabel: "(551) 587-1638",
      heroBackgroundImage:
        "https://images.unsplash.com/photo-1560518883-ce09059eeffa?q=80&w=2073&auto=format&fit=crop&ixlib=rb-4.0.3",
      cardData: [
        {
          title: "Home Buying Services",
          description:
            "Expert guidance through every step of the home buying process with access to exclusive listings and market insights.",
        },
        {
          title: "Home Selling Solutions",
          description:
            "Strategic marketing and pricing expertise to maximize your home's value using EXP Realty's advanced technology platform.",
        },
        {
          title: "Investment Properties",
          description:
            "Comprehensive real estate investment services helping you build wealth through strategic property acquisitions.",
        },
      ],
      description:
        "Carlos Cabral brings dedicated expertise and EXP Realty's innovative technology to help you achieve your real estate goals in Montclair and throughout New Jersey.",
    },
    sectionC: {
      servicesTitle: "Professional Real Estate Services",
      servicesDescription:
        "Comprehensive real estate solutions backed by EXP Realty's cutting-edge technology, global community, and unrivaled tools for success in today's market.",
      cards: [
        {
          title: "Residential Sales",
          description:
            "Expert representation for buying and selling homes in Montclair, Essex County, and throughout New Jersey with personalized attention to your unique needs.",
          imageSrc: "https://images.unsplash.com/photo-1570129477492-45c003edd2be?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3",
          imageAlt: "Residential Real Estate Sales",
        },
        {
          title: "Market Analysis & Pricing",
          description:
            "Detailed market insights and competitive pricing strategies using EXP Realty's advanced analytics to position your property for success.",
          imageSrc: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3",
          imageAlt: "Real Estate Market Analysis",
        },
        {
          title: "Client Support & Technology",
          description:
            "24/7 support with state-of-the-art technology tools, virtual tours, digital marketing, and seamless transaction management.",
          imageSrc: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?q=80&w=2084&auto=format&fit=crop&ixlib=rb-4.0.3",
          imageAlt: "Real Estate Technology Services",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "First-Time Homebuyer Programs",
        "Luxury Property Specialists",
        "Relocation Services",
        "Commercial Real Estate",
        "Property Management Referrals",
      ],
    },
    sectionD: {
      aboutTitle: "About Carlos Cabral",
      aboutImage: {
        src: "https://www.carloscsellshomes.com/wp-content/uploads/sites/25449/2025/10/Carlos-300x300.png",
        alt: "Carlos Cabral Real Estate Professional",
      },
      aboutText: [
        "Carlos Cabral is a dedicated real estate professional with EXP Realty, bringing personalized service and expert market knowledge to clients throughout Montclair and New Jersey. As part of the fastest-growing real estate brokerage in the world, Carlos leverages cutting-edge technology and innovative tools to deliver exceptional results.",
        "With EXP Realty's unique cloud-based model and global community of agents, Carlos provides clients with unparalleled resources and support. Whether you're buying your first home, selling to upgrade, or exploring investment opportunities, Carlos is committed to making your real estate journey smooth, successful, and rewarding.",
      ],
    },
    sectionE: {
      profileImage: "",
      profileAlt: "Carlos Cabral EXP Realty",
      businessName: "Carlos Cabral EXP Realty",
      contact: {
        phone: "5515871638",
        phoneLabel: "(551) 587-1638",
        email: "carlos.cabral.280608@exprealty.com",
        website: "https://www.carloscsellshomes.com/",
        address: "28 Valley Road, Suite 1, Montclair, NJ 07042",
      },
      socialMedia: {
      },
    },
    sectionF: {
      address: "28 Valley Road, Suite 1, Montclair, NJ 07042",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3021.123456789!2d-74.2085567!3d40.8176234!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2fe123456789a%3A0x1234567890abcdef!2s28%20Valley%20Rd%20%231%2C%20Montclair%2C%20NJ%2007042!5e0!3m2!1sen!2sus!4v1698765432100!5m2!1sen!2sus",
    },
  },
};

export default config;